import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { MONTHLY_INTERVAL, YEARLY_INTERVAL } from 'constants/plans';
import { Wrapper, MonthlyPlan, YearlyPlan } from './styled';

const IntervalSelector = ({
  isViewMode,
  interval = MONTHLY_INTERVAL,
  onChangeInterval,
}) => {
  const [selectedInterval, setSelectedInterval] = useState(interval);
  const [prevInterval, setPrevInterval] = useState(interval);

  if (interval !== prevInterval) {
    setPrevInterval(interval);
    setSelectedInterval(interval);
  }

  return (
    <Wrapper isViewMode={isViewMode}>
      {onChangeInterval && (
        <>
          <MonthlyPlan
            selected={selectedInterval === MONTHLY_INTERVAL}
            onClick={() => {
              if (isViewMode) return;
              setSelectedInterval(MONTHLY_INTERVAL);
              onChangeInterval(MONTHLY_INTERVAL);
            }}
          >
            Monthly
          </MonthlyPlan>
          <YearlyPlan
            selected={selectedInterval === YEARLY_INTERVAL}
            onClick={() => {
              if (isViewMode) return;
              setSelectedInterval(YEARLY_INTERVAL);
              onChangeInterval(YEARLY_INTERVAL);
            }}
          >
            Annual
          </YearlyPlan>
        </>
      )}
    </Wrapper>
  );
};

IntervalSelector.propTypes = {
  interval: PropTypes.string,
  isViewMode: PropTypes.bool,
  onChangeInterval: PropTypes.func,
};

export default IntervalSelector;
